function getOverlay() {
  let overlay = document.querySelector('.colorway-preview-overlay');
  if (overlay) return overlay;

  const gallery = document.querySelector('media-gallery');
  if (!gallery) return null;

  overlay = document.createElement('img');
  overlay.className = 'colorway-preview-overlay';
  overlay.alt = '';
  gallery.appendChild(overlay);
  return overlay;
}

function showPreview(swatch) {
  if (!swatch.dataset.previewSrc) return;
  const overlay = getOverlay();
  if (!overlay) return;
  overlay.src = swatch.dataset.previewSrc;
  overlay.srcset = swatch.dataset.previewSrcset || '';
  overlay.classList.add('is-visible');
}

function hidePreview() {
  const overlay = document.querySelector('.colorway-preview-overlay');
  if (overlay) overlay.classList.remove('is-visible');
}

document.addEventListener('mouseover', (event) => {
  const swatch = event.target.closest('.colorway-picker__swatch[data-preview-src]');
  if (swatch) showPreview(swatch);
});

document.addEventListener('mouseout', (event) => {
  const swatch = event.target.closest('.colorway-picker__swatch[data-preview-src]');
  if (!swatch) return;
  const picker = swatch.closest('.colorway-picker');
  if (picker && picker.contains(event.relatedTarget)) return;
  hidePreview();
});

document.addEventListener('focusin', (event) => {
  const swatch = event.target.closest('.colorway-picker__swatch[data-preview-src]');
  if (swatch) showPreview(swatch);
});

document.addEventListener('focusout', (event) => {
  const swatch = event.target.closest('.colorway-picker__swatch[data-preview-src]');
  if (!swatch) return;
  const picker = swatch.closest('.colorway-picker');
  if (picker && picker.contains(event.relatedTarget)) return;
  hidePreview();
});
